import { render, staticRenderFns } from "./StickyMenu.vue?vue&type=template&id=4b55f93f&scoped=true&"
import script from "./StickyMenu.vue?vue&type=script&lang=js&"
export * from "./StickyMenu.vue?vue&type=script&lang=js&"
import style0 from "./StickyMenu.vue?vue&type=style&index=0&id=4b55f93f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b55f93f",
  null
  
)

export default component.exports